import { ICommandEvent } from './command-event.i';
import { CommandMapper } from './mapper/command-mapper.svc';
import { EventSource } from './command-event-data.i';

/**
 * This class is an abstraction for a list of constants
 * that define the command names of each command. The extending
 * classes such as <code>DiagramCommandEvent</code> will include
 * a list of diagram events that associate to command, for example.
 *
 * These events associate to one or more commands. When the event
 * is dispatched to the command system, the associated commands
 * run in the configured pattern. See more in <code>CommandService</code>
 *
 * @author  hiraash
 * @since   2016-03-26
 */
export class CommandEvent implements ICommandEvent {
    /**
     * Call all static methods which starts with "register" with the mapper.
     */
    public static register( mapper: CommandMapper ) {
        // tslint:disable-next-line:forin
        const propertyNames = Object.getOwnPropertyNames( this );
        for ( const propName of propertyNames ) {
            const property: any = this[propName];
            if ( propName === 'register' ||
                !propName.startsWith( 'register' ) ||
                typeof property !== 'function' ) {
                continue;
            }
            property.call( this, mapper );
        }
    }

    protected _value: string;
    protected source: string;
    protected dataTransformer?: CallableFunction;

    public constructor( event: string, source: EventSource = EventSource.USER, dataTransformer?: CallableFunction ) {
        this._value = event;
        this.source = source;
        this.dataTransformer = dataTransformer;
    }

    public toString() {
        return this._value;
    }

    public getSource() {
        return this.source;
    }

    public transformData( data: any ) {
        if ( this.dataTransformer ) {
            return this.dataTransformer( data );
        }
        return data;
    }
}

/**
 * AbstractDiagramCommandEvent is the base class for the DiagramCommandEvent
 * class. Currently, this is only used to enforce the resourceId parameter
 * on CommandService dispatch method.
 */
export class AbstractDiagramCommandEvent extends CommandEvent {}

/**
 * AbstractProjectCommandEvent is the base class for the ProjectCommandEvent
 * class. Currently, this is only used to enforce the resourceId parameter
 * on CommandService dispatch method.
 */
export class AbstractProjectCommandEvent extends CommandEvent {}


/**
 * AbstractEDataCommandEvent is the base class for the ProjectCommandEvent
 * class. Currently, this is only used to enforce the resourceId parameter
 * on CommandService dispatch method.
 */
// tslint:disable-next-line:max-classes-per-file
export class AbstractEDataCommandEvent extends CommandEvent {}
